const focusBorder = "var(--app-component-focus-border-color)";
const themeBorder = "var(--app-component-border-color)";
const themeColor = "var(--app-component-color)";
const themeBg = "var(--app-component-bg)";
const dropdownBg = "var(--app-component-dropdown-bg)";
const focusShadow =
  "0 0 0 0.25rem rgba(var(--app-component-active-bg-rgb), 0.25)";

const selectStyles = {
  control: (defaultStyles, state) => ({
    ...defaultStyles,
    paddingLeft: "0.75rem",
    backgroundColor: state.isDisabled
      ? "var(--app-component-disabled-bg)"
      : themeBg,
    border: `1px solid ${state.isFocused ? focusBorder : themeBorder}`,
    borderColor: state.isFocused ? focusBorder : themeBorder,
    boxShadow: state.isFocused ? focusShadow : undefined,
    outline: "none",
    transition: "border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
    fontWeight: "600",
    fontSize: "13px",
    height: "45px",
    color: themeColor,
    "&:hover": {
      borderColor: state.isFocused ? focusBorder : themeBorder,
    },
  }),
  singleValue: (defaultStyles) => ({
    ...defaultStyles,
    color: themeColor,
  }),
  input: (defaultStyles) => ({
    ...defaultStyles,
    color: themeColor,
  }),
  valueContainer: (defaultStyles) => ({
    ...defaultStyles,
    padding: "0",
  }),
  placeholder: (defaultStyles) => ({
    ...defaultStyles,
    color: "#6c757d",
    opacity: 1,
  }),
  indicatorSeparator: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: themeBorder,
  }),
  dropdownIndicator: (defaultStyles, state) => ({
    ...defaultStyles,
    color: state.isFocused ? themeColor : "#6c757d",
    "&:hover": {
      color: themeColor,
    },
  }),
  clearIndicator: (defaultStyles) => ({
    ...defaultStyles,
    color: "#6c757d",
    "&:hover": {
      color: themeColor,
    },
  }),
  menu: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: dropdownBg,
    border: "1px solid var(--app-component-dropdown-border-color)",
    boxShadow: "0 0.5rem 1rem rgba(0, 0, 0, 0.15)",
    zIndex: 5,
  }),
  menuList: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: dropdownBg,
  }),
  option: (defaultStyles, state) => ({
    ...defaultStyles,
    backgroundColor: state.isSelected
      ? "var(--app-component-active-bg)"
      : state.isFocused
      ? "var(--app-component-dropdown-hover-bg)"
      : dropdownBg,
    color: state.isSelected ? "var(--app-component-active-color)" : themeColor,
    cursor: "pointer",
    ":active": {
      backgroundColor: "var(--app-component-active-bg)",
      color: "var(--app-component-active-color)",
    },
  }),
  multiValue: (defaultStyles) => ({
    ...defaultStyles,
    backgroundColor: "var(--app-component-hover-bg)",
  }),
  multiValueLabel: (defaultStyles) => ({
    ...defaultStyles,
    color: themeColor,
  }),
  multiValueRemove: (defaultStyles) => ({
    ...defaultStyles,
    color: "#6c757d",
    ":hover": {
      backgroundColor: "var(--app-component-active-bg)",
      color: "var(--app-component-active-color)",
    },
  }),
  noOptionsMessage: (defaultStyles) => ({
    ...defaultStyles,
    color: themeColor,
  }),
  loadingMessage: (defaultStyles) => ({
    ...defaultStyles,
    color: themeColor,
  }),
};

export default selectStyles;
